import {
    Box,
    CircularProgress,
    Divider,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import WSButton from "../../Components/Button/WSButton";

import { callAPI, Method } from "../../commonFunctions/CommonFunctions";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import { NotFound } from "../NotFound";
import logo from '../../images/logo.svg'
const EMartinPrint: React.FC = () => {
    const { id } = useParams();
    const contentRef = useRef<HTMLDivElement>(null);
    const { showMessage } = useSnackbar();

    const [data, setData] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(true);

    const paymentStages = [
        { description: "Approximate Estimation", percentage: null },
        { description: "Advance 30%", percentage: 30 },
        { description: "Unload Time 60%", percentage: 60 },
        { description: "After Completion 10%", percentage: 10 }
    ];

    useEffect(() => {
        async function getDataById() {
            try {
                const response: any = await callAPI("estimates", Method.GET, null, id);
                if (response?.data) {
                    setData(response.data);
                }
            } catch (error) {
                showMessage("Something went wrong. Please try again.", "error");
            } finally {
                setLoading(false);
            }
        }

        if (id) {
            getDataById();
        }
    }, [id]);

    // 🖨️ Print Handler
    const handlePrint = useReactToPrint({
        contentRef
    });

    if (loading)
        return (
            <Box display="flex" justifyContent="center" mt={4}>
                <CircularProgress />
            </Box>
        );
    if (!data) return <NotFound />;
    const bank1 = [
        ["Account Holder", "EVER SHINECEMENT PRODUCT"],
        ["Bank Name", "MADAI COOPERATIVE BANK"],
        ["A/c No.", "6441"],
        ["Branch", "ERIAM"],
        ["IFSC", ""],
        ["G Pay No.", "97 47 535 535 (MHB JOSEPH)"]
    ];

    const bank2 = [
        ["Account Holder", "MARTIN INDUSTRIES"],
        ["Bank Name", "FEDERAL BANK"],
        ["A/c No.", "11270200020614"],
        ["Branch", "THALIPARAMBA"],
        ["IFSC", "FDRL0001127"],
        ["G Pay No.", "97 47 535 535 (MHB JOSEPH)"]
    ];
    const renderTable = (details: string[][]) => (
        <TableContainer sx={{ borderRadius: 2, boxShadow: 1 }}>
            <Table size="small">
                <TableBody>
                    {details.map(([label, value], index) => (
                        <TableRow
                            key={index}
                            sx={{ bgcolor: index % 2 ? "grey.100" : "white" }}
                        >
                            <TableCell sx={{ fontWeight: 500, fontSize: '0.75rem' }}> <Typography sx={{ fontSize: '0.75rem' }}>{label}:</Typography></TableCell>
                            <TableCell align="right"> <Typography sx={{ fontSize: '0.75rem' }}>{value}</Typography></TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            p={4}
            bgcolor="grey.100"
            minHeight="100vh"
        >
            <WSButton
                id="printBtn"
                size="small"
                label="Print Estimation"
                onClick={handlePrint}
            />

            <Box
                ref={contentRef}
                mt={2}
                sx={{ p: 4, width: "100%", maxWidth: "800px", bgcolor: "white" }}
            > 
            {/* <Box ml={2} display={'flex'} justifyContent={'flex-end'}>
                    <img src={logo} alt="Company Logo" style={{ objectFit: "contain" }} />
                </Box> */}
                {/* Company Header */}
                <Box textAlign="center" borderBottom={1} pb={2} mb={2}>
                    <Typography variant="h4" fontWeight="bold" color="error" fontStyle={'italic'}>
                        MARTIN INDUSTRIES
                    </Typography>
                    {/* <Typography variant="subtitle1">Make Home Beautiful</Typography>
          <Typography variant="body2">
            E.mail: mhbinterlock@gmail.com | mhb-Industries
          </Typography> */}
                    <Typography variant="body2">
                        Edakkom P.O, Kannur District, Kerala – 670581
                    </Typography>
                    <Typography variant="body2">PH: 9747535535, 9544541114/17</Typography>
                    <Typography variant="body2"> EMail: mhbinterlock@gmail.com  GSTIN: 32AMMJPP7959E1ZP  </Typography>
                </Box>


                {/* Estimate Details */}
                <Box textAlign="left" mb={1}>
                    <Typography sx={{ fontSize: '0.875rem' }}>
                        To,
                    </Typography>
                    <Typography sx={{ fontSize: '0.875rem', paddingLeft: 2 }}>{data.customerName}</Typography>
                    <Typography sx={{ fontSize: '0.875rem', paddingLeft: 2 }}>Site at {data.address}.</Typography>
                </Box>

                {/* Estimation Details */}
                <Box textAlign="center" mb={2} sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
                    <Typography sx={{ fontSize: '1rem', fontWeight: 'bold' }}>Estimation</Typography>
                    {/* <Typography variant="body2">
            Valid Till: {new Date(data.validTill).toLocaleDateString()}
          </Typography> */}
                </Box>

                <Box mb={2}>
                    <Typography sx={{ fontSize: '0.875rem' }}>Dear sir/madam</Typography>
                    <Typography sx={{ fontSize: '0.875rem' }}>
                        {data.subject}
                    </Typography>
                </Box>

                {/* Table */}
                <TableContainer component={Paper}>
                    <Table size="small" >
                        <TableHead>
                            {/* <TableRow>
                                <TableCell sx={{ bgcolor: "darkgray", fontWeight: 700 }}>
                                    <Typography sx={{ fontSize: '0.875rem' }} fontWeight={700}>
                                        REQUIRED ITEMS
                                    </Typography>
                                </TableCell>
                                <TableCell sx={{ bgcolor: "lightgray", fontWeight: 700, textAlign: "center" }} colSpan={3}>
                                    <Typography sx={{ fontSize: '0.875rem' }} fontWeight={700}>
                                        WORK INCLUDED
                                    </Typography>

                                </TableCell>
                            </TableRow> */}
                            <TableRow sx={{ bgcolor: "grey.300" }}>
                                <TableCell> <Typography sx={{ fontSize: '0.80rem' }} >PARTICULAR</Typography></TableCell>
                                <TableCell align="center"> <Typography sx={{ fontSize: '0.80rem' }} >QTY</Typography></TableCell>
                                <TableCell align="center"> <Typography sx={{ fontSize: '0.80rem' }} >RATE</Typography></TableCell>
                                <TableCell align="center"> <Typography sx={{ fontSize: '0.80rem' }} >AMOUNT</Typography></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.estimateItems
                                // .filter((item: any) => item.isIncluded)
                                .map((item: any, index: number) => (
                                    <TableRow key={index}>
                                        <TableCell>{item.productName}</TableCell>
                                        <TableCell align="center"><Typography sx={{ fontSize: '0.75rem' }} >{item.quantity}</Typography></TableCell>
                                        <TableCell align="center"><Typography sx={{ fontSize: '0.75rem' }} >{item.unitPrice}</Typography></TableCell>
                                        <TableCell align="center"><Typography sx={{ fontSize: '0.75rem' }} >{item.totalPrice}</Typography></TableCell>
                                    </TableRow>
                                ))}

                            {/* TOTAL row */}
                            <TableRow>
                                <TableCell sx={{ fontWeight: 700 }}><Typography sx={{ fontSize: '0.75rem', fontWeight: 700 }} >TOTAL</Typography></TableCell>
                                <TableCell align="center" sx={{ fontWeight: 700 }}>
                                    <Typography sx={{ fontSize: '0.75rem', fontWeight: 700 }} >{data.estimateItems
                                        .filter((item: any) => item.isIncluded)
                                        .reduce((sum: number, item: any) => sum + Number(item.quantity), 0)}</Typography>
                                </TableCell>
                                <TableCell align="center" sx={{ fontWeight: 700 }}>
                                    <Typography sx={{ fontSize: '0.75rem', fontWeight: 700 }} >{data.estimateItems
                                        .filter((item: any) => item.isIncluded)
                                        .reduce((sum: number, item: any) => sum + Number(item.unitPrice), 0)
                                        .toLocaleString()}</Typography>
                                </TableCell>
                                <TableCell align="center" sx={{ fontWeight: 700 }}>
                                    <Typography sx={{ fontSize: '0.75rem', fontWeight: 700 }} >{data.estimateItems
                                        .filter((item: any) => item.isIncluded)
                                        .reduce((sum: number, item: any) => sum + Number(item.totalPrice), 0)
                                        .toLocaleString()}</Typography>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>

                <Box mt={1}>
                    <Typography sx={{ fontWeight: 700, mb: 0, fontSize: '0.875rem' }}>
                        Mode of Payment:
                    </Typography>
                    <ul style={{ marginTop: 0 }}>
                        <li>
                            <Typography sx={{ fontSize: '0.75rem' }}>
                                <b>40%</b> of total value of work on order confirmation.
                            </Typography>
                        </li>
                        <li>
                            <Typography sx={{ fontSize: '0.75rem' }}>
                                The balance<b>60%</b> to be paid after the completion of work.
                            </Typography>
                        </li>
                    </ul>
                </Box>

                {/* Terms and Condtion */}

                <Box mt={2}>
                    <Typography variant="h6" sx={{ fontWeight: 700, mb: 1, fontSize: '0.875rem' }}>
                        Terms and Conditions.
                    </Typography>
                    <Typography sx={{ pl: 2, fontSize: '0.75rem' }}>
                        1. The required electrical work shall be carried out at the customer’s discretion and expanses
                    </Typography>
                    <Typography sx={{ pl: 2, fontSize: '0.75rem' }}>
                        2. It is the responsibility of customer install the gate properly and smooth aliment.
                    </Typography>
                    <Typography sx={{ pl: 2, fontSize: '0.75rem' }}>
                        3 . Two Year guarantee for the automation device, but damage    caused by lighting or excessive current is not allowed guaranteed.

                    </Typography>

                </Box>

                {/* Payment Terms */}

                {/* Footer */}
                <Divider sx={{ my: 3 }} />
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="flex-end"
                >
                    <Box textAlign="left">
                        <Typography sx={{ fontSize: '0.875rem' }}>Thanks & Regards,</Typography>
                        <Typography fontWeight="bold" sx={{ fontSize: '0.875rem' }}>JOSEPH PJ</Typography>
                        <Typography sx={{ fontSize: '0.875rem' }}>Martin Industries</Typography>
                        <Typography sx={{ fontSize: '0.875rem' }}>9544541112/3/4</Typography>
                    </Box>
                </Box>


            </Box>
        </Box>
    );
};

export default EMartinPrint;
